/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const generateTitleAudioIdsBodySchema = z.object({
  limit: z.number().min(1).max(10000).default(1000),
  force: z.boolean().optional().default(false),
  fullAudio: z.boolean().optional().default(false),
});

export type IGenerateTitleAudioIdsBody = z.infer<typeof generateTitleAudioIdsBodySchema>;
